
const state = {
  menuActive:''
}

const mutations = {
  SET_MENUINDX: (state, index) => {
    state.menuActive = index
  },
}

const actions = {
	setMenuIndex({ commit }, index) {
	  commit('SET_MENUINDX', index)
	},
}

export default {
	namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js